/**
 * Scrolling a full-screen tile area one row at a time (issues #123, #124).
 *
 * Shared by the tiled layout and the pinned layout's column, whose "N more
 * below" chips both scroll one row per click.
 */

function prefersReducedMotion(): boolean {
  return typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Scrolls `element` down by `step` pixels: smoothly, or at once under reduced motion. */
export function scrollDownBy(element: HTMLElement, step: number): void {
  if (typeof element.scrollBy === 'function') {
    element.scrollBy({ top: step, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  } else {
    element.scrollTop += step;
  }
}
